if (!customElements.get('icons-slider')) {
    customElements.define(
      'icons-slider',
      class IconsSlider extends HTMLElement {
        constructor() {
          super();
  
          this.selectors = {
            viewer: '[id^="GalleryViewer"]',
            mediaList: '[id^="Slider-Gallery"]',
            mediaItems: ['.icon-with-text__item'],
          };
  
          this.sliderInstance = false;
        }
  
        connectedCallback() {
          this.init();
        }
  
        init() {
          this.elements = window.FoxTheme.utils.queryDomNodes(this.selectors, this);
          this.setSliderOptions();
  
          const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
          mql.onchange = this.updateMediaLayout.bind(this);
          this.initSlider();
        }
  
        setSliderOptions() {
  
            this.sliderOptions = {
                init: false,
                slidesPerView: '1',
                centeredSlides: true,
                loop: true,
                autoplay: { delay: 4000, pauseOnMouseEnter: true },
                grabCursor: true,
                allowTouchMove: true,
                autoHeight: true,
                pagination: {
                el: this.querySelector('.swiper-pagination-icons'),
                clickable: true,
                type: 'bullets',
                },
                threshold: 2,
            };
        }
  
        updateMediaLayout() {
          if (FoxTheme.config.mqlMobile) {
            this.initSlider();
          } else {
            if (this.enableDesktopSlider) {
              this.initSlider();
            } else {
              this.destroySlider();
            }
          }
        }
  
        initSlider() {
          if (typeof this.sliderInstance !== 'object') {
  
            this.sliderInstance = new window.FoxTheme.Carousel(this.elements.viewer, this.sliderOptions, FoxTheme.Swiper.Autoplay);
            this.sliderInstance.init();
  
            this.handleSliderAfterInit();
            this.handleSlideChange();
  
            this.sliderInstance.slider.init();
          }
        }
  
        destroySlider() {
          if (typeof this.sliderInstance === 'object') {
            this.sliderInstance.slider.destroy();
            this.sliderInstance = false;
          }
        }
  
        handleSliderAfterInit() {
          this.sliderInstance.slider.on('afterInit', (swiper) => {
            const { slides, activeIndex } = swiper;
  
            if (slides[activeIndex]) {
              const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
              this.toggleSliderDraggableState(!isModelMediaType);
            }
          });
        }
  
        handleSlideChange() {
          this.sliderInstance.slider.on('realIndexChange', (swiper) => {
            const { slides, activeIndex, thumbs } = swiper;
  
            if (slides[activeIndex]) {
              this.playActiveMedia(slides[activeIndex]);
  
              const isModelMediaType = slides[activeIndex].dataset.mediaType === 'model';
              this.toggleSliderDraggableState(!isModelMediaType);
            }
          });
        }
  
        toggleSliderDraggableState(isDraggable) {
          if (this.sliderInstance.slider.allowTouchMove !== isDraggable) {
            this.sliderInstance.slider.allowTouchMove = isDraggable;
          }
        }
  
        playActiveMedia(selected) {
          const deferredMedia = selected.querySelector('product-model');
          if (deferredMedia) deferredMedia.loadContent(false);
        }
  
        setActiveMedia(variant) {
          if (!variant || !variant.hasOwnProperty('featured_media') || !variant.featured_media) return;
  
          if (this.sliderInstance.slider) {
            const slideIndex = variant.featured_media.position || 0;
            this.sliderInstance.slider.slideToLoop(slideIndex - 1);
          } else {
            this.sortMediaItems(variant);
          }
        }
  
        sortMediaItems(variant) {
          let newMedias = this.elements.mediaItems;
  
          // Reset ordering.
          newMedias.sort(function (a, b) {
            return a.dataset.mediaIndex - b.dataset.mediaIndex;
          });
  
          newMedias.some((media, index) => {
            if (media.dataset.mediaId == variant.featured_media.id) {
              const [element] = newMedias.splice(index, 1);
              newMedias.unshift(element);
              return true;
            }
          });
  
          this.elements.mediaList.innerHTML = '';
          newMedias.forEach((media) => {
            this.elements.mediaList.appendChild(media);
          });
  
          if (!FoxTheme.config.mqlMobile) {
            const selectedMedia = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
            if (selectedMedia) {
              window.scrollTo({ top: selectedMedia.offsetTop, behavior: 'smooth' });
            }
          }
        }
      }
    );
  }
  